export const signUpFormDefaultValues = {
  email: '',
  password: '',
  passwordRepeat: '',
  firstName: '',
  lastName: '',
  displayName: '',
  city: '',
  country: null,
  emailOptIn: false,
  persona: '',
  personaOther: '',
};
